import { MemoizedSelector, select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

export namespace StoreUtils {
  export function getValueFromStore<T>(store: Store, selector: MemoizedSelector<Store, T>): T {
    let value;
    store.pipe(select(selector, take(1))).subscribe((data) => (value = data));
    return value;
  }
}
